var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import id from "@irati/utils/id";
import QuantityItem from "./QuantityItem";
var QuantityContainer = /** @class */ (function (_super) {
    __extends(QuantityContainer, _super);
    function QuantityContainer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    QuantityContainer.prototype.render = function () {
        var _this = this;
        var _a = this.props, handleClick = _a.handleClick, products = _a.products, deal = _a.deal;
        return (React.createElement("div", null, products.map(function (item) { return (React.createElement(QuantityItem, { key: item.uuid, id: id(item.name, _this.props), handleClick: handleClick, product: item, deal: deal })); })));
    };
    QuantityContainer.defaultProps = {
        id: "redeem"
    };
    return QuantityContainer;
}(Component));
export default QuantityContainer;
